import { FileX, ShieldAlert } from 'lucide-react';
import { Navigate, useParams } from 'react-router';
import { DetailPageSkeleton } from '../../../../../shared/components/DetailPageSkeleton';
import { EmptyState } from '../../../../../shared/components/EmptyState';
import { useVehicleRegistration } from '../hooks/use-vehicle-registration';
import { legacyUnitTab } from '../policies/legacy-unit-tab';
import { UNITS_TRAIL } from '../components/units-trail';
import { unitPath, type UnitVehicle } from '../units.paths';

/**
 * A truck's or trailer's address by id (`/fleet/trucks/:id/<tab>`, `/fleet/trailers/:id/<tab>`, and the older `/fleet/:id` and
 * `/trailers/:id`) opens its unit, addressed by registration (gitaumoses4/chukua#390), so shared links and links that only know
 * an id keep working.
 */
export function RedirectToUnit({ vehicleKind }: { vehicleKind: UnitVehicle }) {
  const { id = '', tab } = useParams();
  const state = useVehicleRegistration(vehicleKind, id);

  if (state.status === 'loading') return <DetailPageSkeleton label={vehicleKind === 'truck' ? 'Loading truck' : 'Loading trailer'} breadcrumbs={UNITS_TRAIL} />;
  if (state.status === 'not_found') {
    const noun = vehicleKind === 'truck' ? 'Truck' : 'Trailer';
    return <EmptyState icon={FileX} title={`${noun} not found`} description={`This ${noun.toLowerCase()} doesn't exist, or the link is out of date.`} />;
  }
  if (state.status === 'error') {
    return <EmptyState icon={ShieldAlert} title="Couldn't open this vehicle" description="Something went wrong. Try reloading the page." />;
  }
  return <Navigate to={unitPath(state.registration, legacyUnitTab(tab))} replace />;
}
